<template>
    <div class="container mt-0 pt-0">
        <b-row>
            <b-col xl="4" lg="4" md="6" sm="12" v-for="value in storeval">
                <masterCard :headcontent=value.master :img=value.img :content=value.content
                    @click="$router.push(value.routes)">
                </masterCard>
            </b-col>
        </b-row>
    </div>
</template>
    
<script lang="ts">
import { defineComponent } from 'vue'
import masterCard from './MasterMainCard.vue'

export default defineComponent({
    components: {
        masterCard
    },
    props: {
        storeval: {
            type: Object,
            default: []
        },
        route: {
            type: String,
            default: ''
        }
    },
    setup() {
        return {
            // store
        }
    }

})
</script>
    
<style lang="scss" scoped>
.container {

    // background-color: #F8F9FE;
    // height: 100vh;
    .content {
        padding-top: 20px;
        margin-left: 5%;
        margin-right: 5%;

        .search {
            color: #999999;
            text-align: left;
            letter-spacing: 0px;
            display: flex;
            justify-content: space-between;
        }
    }
}
</style>